module.exports = __webpack_public_path__ + "img/header-katrina-hood.413af752.jpg";